module.exports = __webpack_public_path__ + "static/media/grantspass-placeholder.bb2ef4ae.webp";